const UserRoleType = {
  SuperAdmin: 1,
  FacilityAdmin: 2,
  FacilityStaff: 3,
  InvestigatorsStaff: 6,
  PublicDefender: 10,
  PublicDefenderAdmin: 11,
  FacilitySuperAdmin: 12,
  FacilityStaffSAO: 13,
};

const UserRoleName = {
  1: "Super Admin",
  2: "Facility Admin",
  3: "Facility Staff",
  6: "Investigators Staff",
  10: "Public Defender",
  11: "Public Defender Admin",
  12: "Facility Super Admin",
  13: "Facility Staff SAO",
};

const MenuItem = {
  DashboardMenuItem: 1,
  DocumentsMenuItem: 2,
  LockdownMenuItem: 3,
  RevenueReportingMenuItem: 4,
  HousingAreasMenuItem: 5,
  KiosksMenuItem: 6,
  InmatesMenuItem: 7,
  PublicUsersMenuItem: 8,
  RequestsOrGrievancesMenuItem: 9,
  MessagesMenuItem: 10,
  PhotosMenuItem: 11,
  KeywordsMenuItem: 12,
  NoticesMenuItem: 13,
  FacilityMenuItem: 14,
  UserMenuItem: 15,
  RegisteredPublicUsersMenuItem: 26,
  Reporting: 27,
  DndUsers: 28,
  InactiveKiosk: 29,
  PostalMailMenuItem: 30,
  MaintenanceSchedules: 31,
  PaymentReport: 32,
  IPActivity: 33,
  MyWindow: 34,
  KeywordSearch: 35,
  ConnectionRequests: 36,
};

const StoredProcedures = {
  FacilityCPU: "UspFacilityCPU",
  MangementUserCPU: "UspMangementUserCPU",
  MangementUserPWDUpdate: "UspMangementUserPWDUpdate",
  PublicInmateConnectionUpdateByAdmin: "UspPublicInmateConnectionUpdateByAdmin",
  LoadDashBoardInmateStatics: "UspLoadDashBoardInmateStatics",
  LoadCactasService: "UspLoadCactasService",
  MoveInactiveInmatePhotoArchieve: "UspMoveInactiveInmatePhotoArchieve",
  PublicUserDNDCUD: "UspPublicUserDNDCUD",
  LoadTwilionumbersResult: "UspLoadTwilionumbersResult",
  DocumentUpdate: "UspDocumentUpdate",
  DocumentUpload: "UspDocumentUpload",
  DocumentDelete: "UspDocumentDelete",
  InmateInfoUpdateDetails: "UspInmateInfoUpdateDetails",
  MergeInmateDetails: "UspMergeInmateDetails",
  PUIRelationShipUpdateHistory: "UspPUIRelationShipUpdateHistory",
  CloseRequestIRRequestForm: "UspCloseRequestIRRequestForm",
  MessageKeyWordCPU: "UspMessageKeyWordCPU",
  KiosksCPU: "UspKiosksCPU",
  LockDownSettingUpdate: "UspLockDownSettingUpdate",
  MailScanningDocumentUpload: "UspMailScanningDocumentUpload",
  ApproveorRejectMailDocument: "UspApproveorRejectMailDocument",
  InsertPaymentGatewaySetting: "UspInsertPaymentGatewaySetting",
  InsertUpdateApplicationMaintanence: "UspInsertUpdateApplicationMaintanence",
  InmateMessageReviewSave: "UspInmateMessageReviewSave",
  RequestForumMGUserThreadInsert: "UspRequestForumMGUserThreadInsert",
  NoticeDelete: "UspNoticeDelete",
  DeleteStripeDuplicatePayment: "UspDeleteStripeDuplicatePayment",
  PhotoApproveOrReject: "UspPhotoApproveOrReject",
  PodCPU: "UspPodCPU",
  RequestPublicDefenderThreadRespond: "UspRequestPublicDefenderThreadRespond",
  MoveForumFormToNewForum: "UspMoveForumFormToNewForum",
  PublicNotesInsertUpdate: "UspPublicNotesInsertUpdate",
  ComplimentaryCreditInsert: "UspComplimentaryCreditInsert",
  PublicInmateConnectionBlockUnBlock: "UspPublicInmateConnectionBlockUnBlock",
  PurchaseOrderTransactionUpdateWeb: "UspPurchaseOrderTransactionUpdateWeb",
  PurchaseOrderTransactionUpdate: "UspPurchaseOrderTransactionUpdate",
  ManuallyDecreaseCredit: "UspManuallyDecreaseCredit",
  UsingIframe: "Using Iframe",
  PublicUserUpdateStatus: "UspPublicUserUpdateStatus",
  UpdatePublicUserReSendEmailWeb: "UpdatePublicUserReSendEmailWeb",
  RequestAdminRemedyRespond: "UspRequestAdminRemedyRespond",
  ChangedFormType: "Changed Form Type",
};

const SubMenuItem = {
  AddSubMenuItem: 16,
  ModifySubMenuItem: 17,
  DeleteSubMenuItem: 18,
  ActivateSubMenuItem: 19,
  DeactivateSubMenuItem: 20,
  UploadSubMenuItem: 21,
  ViewSubMenuItem: 22,
  ReviewSubMenuItem: 23,
  RespondSubMenuItem: 24,
  AssignInvestigatorSubMenuItem: 25,
  LegalMailSubMenuItem: 37,
};

// export { UserRoleType, MenuItem, StoredProcedures, UserRoleName, SubMenuItem };
// const StoredProcedures = {
//   FacilityCPU :"UspFacilityCPU",
//   MangementUserCPU:"UspMangementUserCPU",
//   MangementUserPWDUpdate:"UspMangementUserPWDUpdate",
//   PublicInmateConnectionUpdateByAdmin:"UspPublicInmateConnectionUpdateByAdmin",
//   LoadDashBoardInmateStatics:"UspLoadDashBoardInmateStatics",
//   LoadCactasService:"UspLoadCactasService",
//   PublicUserDNDCUD:"UspPublicUserDNDCUD",
//   LoadTwilionumbersResult:"UspLoadTwilionumbersResult",
//   DocumentUpdate:"UspDocumentUpdate",
//   DocumentUpload:"UspDocumentUpload",
//   DocumentDelete:"UspDocumentDelete",
//   InmateInfoUpdateDetails:"UspInmateInfoUpdateDetails",
//   MergeInmateDetails:"UspMergeInmateDetails",
//   PUIRelationShipUpdateHistory:"UspPUIRelationShipUpdateHistory",
//   CloseRequestIRRequestForm:"UspCloseRequestIRRequestForm",
//   MessageKeyWordCPU:"UspMessageKeyWordCPU",
//   KiosksCPU:"UspKiosksCPU",
//   LockDownSettingUpdate:"UspLockDownSettingUpdate",
//   MailScanningDocumentUpload:"UspMailScanningDocumentUpload",
//   ApproveorRejectMailDocument:"UspApproveorRejectMailDocument",
//   InsertPaymentGatewaySetting:"UspInsertPaymentGatewaySetting",
//   InsertUpdateApplicationMaintanence:"UspInsertUpdateApplicationMaintanence",
//   InmateMessageReviewSave:"UspInmateMessageReviewSave",
//   RequestForumMGUserThreadInsert:"UspRequestForumMGUserThreadInsert",
//   NoticeDelete:"UspNoticeDelete",
//   DeleteStripeDuplicatePayment:"UspDeleteStripeDuplicatePayment",
//   PhotoApproveOrReject:"UspPhotoApproveOrReject",
//   PodCPU:"UspPodCPU",
//   RequestPublicDefenderThreadRespond:"UspRequestPublicDefenderThreadRespond",
//   MoveForumFormToNewForum:"UspMoveForumFormToNewForum",
//   PublicNotesInsertUpdate:"UspPublicNotesInsertUpdate",
//   ComplimentaryCreditInsert:"UspComplimentaryCreditInsert",
//   PublicInmateConnectionBlockUnBlock:"UspPublicInmateConnectionBlockUnBlock",
//   PurchaseOrderTransactionUpdateWeb:"UspPurchaseOrderTransactionUpdateWeb",
//   PurchaseOrderTransactionUpdate:"UspPurchaseOrderTransactionUpdate",
//   ManuallyDecreaseCredit:"UspManuallyDecreaseCredit",
//   UsingIframe:"Using Iframe",
//   PublicUserUpdateStatus:"UspPublicUserUpdateStatus",
//   UpdatePublicUserReSendEmailWeb:"UpdatePublicUserReSendEmailWeb",
//   RequestAdminRemedyRespond:"UspRequestAdminRemedyRespond",
//   ChangedFormType:"Changed Form Type",
// }

const DaysFlag = {
  sunday: 1,
  monday: 2,
  tuesday: 3,
  wednesday: 4,
  thursday: 5,
  friday: 6,
  saturday: 7,
};

export {
  UserRoleType,
  MenuItem,
  StoredProcedures,
  UserRoleName,
  DaysFlag,
  SubMenuItem,
};
